// Holds the Redux store without importing store/store. Modules that need the
// store at call time (services/api/Api, DisplayItemsService,
// UserManagementService) read it from here:
// importing store/store directly pulls in every saga, selector and reducer and
// creates import cycles. configureStore() sets it; it is null until then.
let currentStore = null;

export const setStore = (store) => {
  currentStore = store;
};

export const getStore = () => currentStore;
